import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input, Table } from 'reactstrap';
import DescuentosService from '../../axios_services/descuentotardanza.service';
import { ButtonDelete, ButtonSave } from '../Buttons/Buttons';

const ModalDescuentoOtros = ({ isOpen, onClose, onSaved, registro, mes }) => {
    const [entries, setEntries] = useState([]);
    const [addingRows, setAddingRows] = useState([{ descripcion: '', monto_descuento: '' }]);
    const [isLoading, setIsLoading] = useState(false);

    const formatoSoles = (v) =>
        new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format(v);

    const loadEntries = async () => {
        if (!registro?.usuario_id || !mes) return;
        try {
            const res = await DescuentosService.getOtrosPorUsuario(mes, registro.usuario_id);
            setEntries(res.data || []);
            setAddingRows([{ descripcion: '', monto_descuento: '' }]);
        } catch {
            setEntries([]);
            setAddingRows([{ descripcion: '', monto_descuento: '' }]);
        }
    };

    useEffect(() => {
        if (isOpen) {
            loadEntries();
        }
    }, [isOpen, registro, mes]);

    const handleUpdateAddingRow = (index, field, value) => {
        const newRows = [...addingRows];
        newRows[index][field] = value;
        setAddingRows(newRows);
    };

    const handleSaveRow = async (index) => {
        const row = addingRows[index];
        if (!row.descripcion.trim() || !row.monto_descuento || isNaN(row.monto_descuento)) {
            alert('Por favor complete la descripción y un monto válido.');
            return;
        }

        setIsLoading(true);
        try {
            await DescuentosService.storeOtros({
                usuario_id: registro.usuario_id,
                mes,
                motivo: row.descripcion.trim(),
                monto_descuento: parseFloat(row.monto_descuento),
            });
            await loadEntries();
            onSaved();
        } catch (e) {
            alert(e.response?.data?.message || 'Error al guardar');
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('¿Eliminar descuento?')) return;
        setIsLoading(true);
        try {
            await DescuentosService.deleteOtros(id);
            await loadEntries();
            onSaved();
        } catch (e) {
            alert(e.response?.data?.message || 'Error al eliminar');
        } finally {
            setIsLoading(false);
        }
    };

    const totalDescuento = entries.reduce((acc, e) => acc + Number(e.monto_descuento), 0);

    // Estilo para celdas con fondo plomo
    const cellStyle = { backgroundColor: '#ececec', border: '1px solid #adadad' };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>DESCUENTOS: OTROS MOTIVOS</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={(e) => e.preventDefault()}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '15px' }}>
                            <FormGroup className="mb-0">
                                <Label>Colaborador:</Label>
                                <Input className="form-control" type="text" value={registro?.usuario_nombre || ''} disabled />
                            </FormGroup>
                            <FormGroup className="mb-0">
                                <Label>Descuento:</Label>
                                <Input className="form-control text-danger font-weight-bold" type="text" value={formatoSoles(totalDescuento)} disabled />
                            </FormGroup>
                        </div>

                        <div className="mb-2">
                            <Label style={{ fontWeight: 'normal' }}>Detalles:</Label>
                        </div>

                        <div className="table-container" style={{ backgroundColor: 'transparent' }}>
                            <Table hover size="sm" borderless style={{ backgroundColor: 'transparent' }}>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: 'left', paddingLeft: '15px' }}>DESCRIPCIÓN / MOTIVO</th>
                                        <th style={{ width: '150px', textAlign: 'center' }}>MONTO (S/)</th>
                                        <th style={{ width: '100px', textAlign: 'center' }}>ACCIONES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* REGISTROS EXISTENTES */}
                                    {entries.map((e) => (
                                        <tr key={e.otros_id}>
                                            <td style={{ textAlign: 'left', paddingLeft: '15px', ...cellStyle }}>{e.descripcion}</td>
                                            <td style={{ textAlign: 'center', ...cellStyle }}>{formatoSoles(e.monto_descuento)}</td>
                                            <td style={{ ...cellStyle, verticalAlign: 'middle' }}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <ButtonDelete onClick={() => handleDelete(e.otros_id)} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}

                                    {/* FILA SIEMPRE DISPONIBLE PARA AGREGAR */}
                                    {addingRows.map((row, idx) => (
                                        <tr key={`add-${idx}`}>
                                            <td style={{ padding: '4px 10px', ...cellStyle }}>
                                                <Input
                                                    type="text"
                                                    placeholder="Escriba motivo..."
                                                    value={row.descripcion}
                                                    onChange={e => handleUpdateAddingRow(idx, 'descripcion', e.target.value)}
                                                    onKeyDown={(e) => e.key === 'Enter' && handleSaveRow(idx)}
                                                    style={{ border: 'none', backgroundColor: '#fff' }}
                                                    bsSize="sm"
                                                />
                                            </td>
                                            <td style={{ padding: '4px 10px', ...cellStyle }}>
                                                <Input
                                                    type="number"
                                                    placeholder="0.00"
                                                    value={row.monto_descuento}
                                                    onChange={e => handleUpdateAddingRow(idx, 'monto_descuento', e.target.value)}
                                                    onKeyDown={(e) => e.key === 'Enter' && handleSaveRow(idx)}
                                                    style={{ textAlign: 'center', border: 'none', backgroundColor: '#fff' }}
                                                    bsSize="sm"
                                                />
                                            </td>
                                            <td style={{ ...cellStyle, verticalAlign: 'middle' }}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <ButtonSave onClick={() => handleSaveRow(idx)} disabled={isLoading} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalDescuentoOtros;
